import type {Icon} from '@primer/octicons-react'

import styles from './FailureState.module.css'

interface FailureStateProps {
  title: string
  description: string
  icon: Icon
}

export function FailureState({title, description, icon: Icon}: FailureStateProps) {
  return (
    <div className={styles.container}>
      <Icon size={24} className={styles.icon} />
      <h1 className="sr-only">Content preview panel</h1>
      <h2 className={styles.heading}>{title}</h2>
      <p className={styles.subtitle}>{description}</p>
    </div>
  )
}
